class RecordingSocket {
  binaryType = 'arraybuffer'

  /**
   * @param {string} url connection url for debug purposes
   */
  constructor(url) {
    this.url = url
  }

  send() {}

  close() {}

  emit() {}

  onopen = () => {}
  onmessage = () => {}
  onclose = () => {}
}

export default RecordingSocket
